import React from "react";

const ShowErrors = (props) => {
  return (
    <p className='errors'>{props.value}</p>
  );
};

export default ShowErrors;
